export const PROPERTY_PANEL_METADATA_VERSION = 1;

const ACTIVITY_SCOPES = ["activity"];
const HIERARCHY_SCOPES = ["activity", "list", "section"];
const ITEM_SCOPES = ["item"];
const ALL_SCOPES = ["activity", "list", "section", "item"];

const ITEM_MEDIA_PRESENTATION_PROPERTIES = [
	"itemHeight",
	"backgroundImage",
	"video",
	"videoDrive",
	"videoMute",
	"videoLoop",
	"videoAspectRatio",
	"videoAspectRatioCustom",
	"videoFitAvailableSpace",
	"videoMaximumHeight",
	"videoMaximumHeightAnchor",
	"videoShowInBackground",
	"videoResizeMode",
	"videoBackgroundColor",
	"videoOverlayColor",
	"videoOverlayColorCustom",
	"videoTextTracks",
	"videoInlineViewer",
	"videoModalViewer",
	"videoStartTime",
	"videoEndTime",
	"videoLoopSegment",
	"videoResumeBehavior",
	"videoCompletionBehavior",
	"videoActionVisibility",
	"videoCaption",
	"image",
	"imageDrive",
	"imageAspectRatio",
	"imageAspectRatioCustom",
	"imageMaximumHeight",
	"imageMaximumHeightAnchor",
	"imageShowInBackground",
	"imageFitAvailableSpace",
	"backgroundMediaBlurFill",
	"imageResizeMode",
	"imageOverlayColor",
	"imageOverlayColorCustom",
	"imageInlineViewer",
	"imageModalViewer",
	"imageCropMode",
	"imageFocalPoint",
	"imageCropZoom",
	"imageCropRect",
	"imageModalInitialZoom",
	"imageActionVisibility",
	"imageCaption",
	"imageAltText",
	"audio",
	"audioDrive",
	"pdf",
	"pdfDrive",
	"pdfInlineViewer",
	"pdfModalViewer",
	"pdfFitAvailableSpace",
	"pdfViewMode",
	"pdfSinglePage",
	"pdfInitialPage",
	"pdfInitialZoom",
	"pdfPageMode",
	"pdfNamedDestination",
	"pdfSearchText",
	"threeD",
	"threeDDrive"
];

const ACTION_NAV_PROPERTIES = [
	"itemButtonOkLabel",
	"itemButtonBackLabel",
	"itemButtonNotApplicableLabel",
	"itemButtonOkVocabAlternates",
	"itemButtonBackVocabAlternates",
	"itemButtonOkVisibility",
	"itemButtonBackVisibility",
	"itemButtonNotApplicableVisibility",
	"itemButtonOkPendingBehavior",
	"fullscreenActionVariant",
	"fullscreenActionPlacement",
	"fullscreenActionFlowWhenScrollable",
	"fullscreenSwipeNavigation",
	"fullscreenSwipeSound",
	"fullscreenLabelHideControl",
	"fullscreenActionNavAlignment",
	"fullscreenActionNavOrder",
	"fullscreenActionStyle",
	"fullscreenActionPrimaryColor",
	"fullscreenActionSurfaceColor",
	"fullscreenActionToolBackgroundColor",
	"fullscreenActionToolForegroundColor"
];

const COMMENT_TOOL_PROPERTIES = [
	"itemCommentsLabel",
	"itemRelatedItemsLabel",
	"itemAttachmentsLabel",
	"itemCommentsIcon",
	"itemRelatedItemsIcon",
	"itemAttachmentsIcon",
	"itemCommentsBackgroundColor",
	"itemCommentsForegroundColor",
	"itemRelatedItemsBackgroundColor",
	"itemRelatedItemsForegroundColor",
	"itemAttachmentsBackgroundColor",
	"itemAttachmentsForegroundColor"
];

const FILTER_PROPERTIES = [
	"filterTags",
	"showFor"
];

const PRINT_PROPERTIES = [
	"suppressPrint",
	"printProperties",
	"printCustomProperties",
	"printTemplate"
];

export const PROPERTY_PANEL_REGISTRY = [
	{
		anchor: "activity-information",
		title: "Activity Information",
		groupId: "content",
		scopes: ACTIVITY_SCOPES,
		properties: [
			"name",
			"label",
			"description",
			"lang",
			"genre",
			"tags",
			"contributors",
			"driveRootPath"
		],
		contentKeys: [
			"title",
			"description",
			"languageCode",
			"genre",
			"tags",
			"contributors",
			"driveRootPath"
		],
		aliases: ["activity info", "activity details", "activity title"]
	},
	{
		anchor: "title",
		title: "Title",
		groupId: "content",
		scopes: HIERARCHY_SCOPES,
		properties: [
			"name",
			"label",
			"subtitle",
			"nameAlexaPlain",
			"nameAlexaRich",
			"nameAudio",
			"nameSsml",
			"namePrint",
			"nameAudioFile",
			"labelAlexaPlain",
			"labelAlexaRich",
			"labelAudio",
			"labelSsml",
			"labelPrint",
			"labelAudioFile"
		],
		contentKeys: [
			"title",
			"subtitle",
			"titlePlainTextOverride",
			"titleSsmlOverride",
			"titlePrintOverride",
			"titleAudio"
		],
		aliases: ["name", "heading"]
	},
	{
		anchor: "label-1",
		title: "Label 1",
		groupId: "content",
		scopes: ITEM_SCOPES,
		properties: [
			"label",
			"label1",
			"label1AlexaPlain",
			"label1AlexaRich",
			"label1Audio",
			"label1Ssml",
			"label1Print",
			"label1AudioFile",
			"suppressAudioLabel1",
			"speakLabel1ButDontRepeat"
		],
		contentKeys: [
			"label1",
			"label1NarrationOverride",
			"label1SsmlOverride",
			"label1PrintOverride",
			"label1Audio"
		],
		aliases: ["label one", "prompt", "primary label"]
	},
	{
		anchor: "label-2",
		title: "Label 2",
		groupId: "content",
		scopes: ITEM_SCOPES,
		properties: [
			"label2",
			"label2AlexaPlain",
			"label2AlexaRich",
			"label2Audio",
			"label2Ssml",
			"label2Print",
			"label2AudioFile",
			"label2Color",
			"suppressAudioLabel2",
			"speakLabel2ButDontRepeat"
		],
		contentKeys: [
			"label2",
			"label2NarrationOverride",
			"label2SsmlOverride",
			"label2PrintOverride",
			"label2Audio"
		],
		aliases: ["label two", "response", "secondary label"]
	},
	{
		anchor: "comments",
		title: "Comments",
		groupId: "content",
		scopes: ALL_SCOPES,
		properties: [
			"comments",
			"commentsUrl",
			"commentsUrlOpenMode",
			"commentsInline",
			"commentsAudio",
			"commentsSsml",
			"commentsPrint",
			"commentsAudioFile",
			"commentsTemplate",
			"commentsDataPath",
			"commentsVisibility"
		],
		contentKeys: [
			"comments",
			"commentsNarrationOverride",
			"commentsSsmlOverride",
			"commentsPrintOverride",
			"commentsAudio"
		],
		aliases: ["notes", "more info"]
	},
	{
		anchor: "description",
		title: "Description",
		groupId: "content",
		scopes: ACTIVITY_SCOPES,
		properties: ["description"],
		contentKeys: ["description"],
		aliases: ["summary", "activity description"]
	},
	{
		anchor: "visibility",
		title: "Visibility",
		groupId: "content",
		scopes: ALL_SCOPES,
		properties: [
			"enabled",
			"visible",
			"conditionalVisible",
			"isSearchable"
		],
		contentKeys: [
			"enabled",
			"visible",
			"conditionalVisible",
			"isSearchable"
		],
		aliases: ["visible if", "show if", "hide if", "conditional visibility"]
	},
	{
		anchor: "completion-status",
		title: "Completion Status",
		groupId: "content",
		scopes: ALL_SCOPES,
		properties: [
			"ignoreCompletion",
			"hideStatus",
			"mandatory",
			"required",
			"requiredMessage"
		],
		contentKeys: [
			"ignoreCompletion",
			"hideStatus",
			"mandatory",
			"required",
			"requiredMessage"
		],
		aliases: ["required", "mandatory", "completion"]
	},
	{
		anchor: "breadcrumb-bar",
		title: "Breadcrumb Bar",
		groupId: "content",
		scopes: ACTIVITY_SCOPES,
		properties: [
			"breadcrumbBarVisible",
			"breadcrumbSearchBarVisibleAlways"
		],
		contentKeys: [
			"breadcrumbBarVisible",
			"breadcrumbSearchBarVisibleAlways"
		],
		aliases: ["breadcrumbs", "search bar"]
	},
	{
		anchor: "title-card-image",
		title: "Title Card Image",
		groupId: "media",
		scopes: ACTIVITY_SCOPES,
		properties: [
			"heroImage",
			"heroImageDrive"
		],
		contentKeys: ["titleCardImage"],
		aliases: ["hero image", "activity card image", "cover image"]
	},
	{
		anchor: "logo-image-for-normal-large-screens",
		title: "Logo Image (For normal/large screens)",
		groupId: "media",
		scopes: ACTIVITY_SCOPES,
		properties: [
			"logoImage",
			"logoImageDrive",
			"logoImageAlign"
		],
		contentKeys: ["logoImageLarge"],
		aliases: ["large logo", "normal logo", "title bar logo"]
	},
	{
		anchor: "logo-image-for-small-screens",
		title: "Logo Image (For small screens)",
		groupId: "media",
		scopes: ACTIVITY_SCOPES,
		properties: [
			"logoImageSmall",
			"logoImageSmallDrive",
			"logoImageSmallAlign"
		],
		contentKeys: ["logoImageSmall"],
		aliases: ["small logo", "mobile logo"]
	},
	{
		anchor: "background-audio",
		title: "Background Audio",
		groupId: "media",
		scopes: ACTIVITY_SCOPES,
		properties: [
			"backgroundAudio",
			"backgroundAudioDrive",
			"backgroundAudioVolume"
		],
		contentKeys: ["backgroundAudio"],
		aliases: ["soundtrack", "ambient audio"]
	},
	{
		anchor: "itemLayout",
		title: "Media",
		groupId: "media",
		scopes: ALL_SCOPES,
		properties: [
			"backgroundImage",
			"backgroundImageDrive",
			"video",
			"videoDrive",
			"image",
			"imageDrive",
			"audio",
			"audioDrive",
			"pdf",
			"pdfDrive",
			"threeD",
			"threeDDrive"
		],
		contentKeys: ["media"],
		aliases: ["media", "attachments", "background image"]
	},
	{
		anchor: "mediaControls",
		title: "Media Controls",
		groupId: "media",
		scopes: ALL_SCOPES,
		properties: [
			"mediaFullscreenControlVisibility",
			"mediaResizeToggleVisibility",
			"mediaReplayControlVisibility"
		],
		contentKeys: [
			"mediaFullscreenControlVisibility",
			"mediaResizeToggleVisibility",
			"mediaReplayControlVisibility"
		],
		aliases: ["fullscreen control", "resize toggle", "replay control"]
	},
	{
		anchor: "ambifi3d",
		title: "3D Split Screen",
		groupId: "media",
		featureGate: "ambifi3dAuthoring",
		scopes: ALL_SCOPES,
		properties: ["ambifi3d"],
		contentKeys: [
			"ambifi3d",
			"splitScreen",
			"model",
			"camera",
			"material",
			"texture"
		],
		aliases: ["3d split screen", "ambifi 3d", "3d model", "3d camera", "3d texture"]
	},
	{
		anchor: "videoOptions",
		title: "Video Options",
		groupId: "media",
		scopes: ALL_SCOPES,
		properties: ITEM_MEDIA_PRESENTATION_PROPERTIES.filter((property) => property.indexOf("video") === 0),
		contentKeys: ["videoOptions"],
		aliases: ["video settings", "video presentation"]
	},
	{
		anchor: "imageOptions",
		title: "Image Options",
		groupId: "media",
		scopes: ALL_SCOPES,
		properties: ITEM_MEDIA_PRESENTATION_PROPERTIES.filter((property) => property.indexOf("image") === 0 || property === "backgroundMediaBlurFill"),
		contentKeys: ["imageOptions"],
		aliases: ["image settings", "image presentation", "crop", "focal point"]
	},
	{
		anchor: "pdf-options",
		title: "PDF Options",
		groupId: "media",
		scopes: ALL_SCOPES,
		properties: ITEM_MEDIA_PRESENTATION_PROPERTIES.filter((property) => property.indexOf("pdf") === 0),
		contentKeys: ["pdfOptions"],
		aliases: ["browser page mode", "pdf viewer", "document options"]
	},
	{
		anchor: "media-upload-options",
		title: "Media Upload Options",
		groupId: "media",
		scopes: ITEM_SCOPES,
		entityTypes: ["itemImagePicker"],
		properties: [
			"imagePickerMediaType",
			"imagePickerAddMediaButton",
			"imagePickerUploadTitle",
			"imagePickerCaptureMediaTitle",
			"mediaAdd",
			"mediaMax",
			"mediaType"
		],
		contentKeys: [
			"imagePickerMediaType",
			"imagePickerAddMediaButton",
			"imagePickerUploadTitle",
			"imagePickerCaptureMediaTitle"
		],
		aliases: ["upload", "capture media", "add photo"]
	},
	{
		anchor: "layout",
		title: "Basic Options",
		groupId: "layout",
		scopes: ALL_SCOPES,
		properties: [
			"layout",
			"size",
			"defaultView",
			"listTabsVisible",
			"defaultColumnWidth",
			"focusedMode",
			"moveForward",
			"itemsOnSingleLine",
			"startInShowMode",
			"allowSwitchToShowMode",
			"useCustomShowModeStyling",
			"showModeTextAlign",
			"procedureViewType"
		],
		contentKeys: [
			"layout",
			"viewType",
			"listTabsVisible",
			"defaultColumnWidth",
			"focusedMode"
		],
		aliases: ["basic", "view", "presentation mode"]
	},
	{
		anchor: "layoutAdvanced",
		title: "Item Navigation",
		groupId: "navigation",
		scopes: ALL_SCOPES,
		properties: ACTION_NAV_PROPERTIES,
		contentKeys: ACTION_NAV_PROPERTIES,
		aliases: ["fullscreen action", "ok button", "back button", "swipe navigation"]
	},
	{
		anchor: "navigation-title",
		title: "Navigation Title",
		groupId: "navigation",
		scopes: ITEM_SCOPES,
		properties: [
			"navTitle",
			"excludeFromNavigation",
			"relatedItemRefs"
		],
		contentKeys: [
			"navTitle",
			"excludeFromNavigation",
			"relatedItemRefs"
		],
		aliases: ["nav title", "navigation"]
	},
	{
		anchor: "item-tools",
		title: "Item Tools",
		groupId: "layout",
		scopes: ALL_SCOPES,
		properties: COMMENT_TOOL_PROPERTIES,
		contentKeys: COMMENT_TOOL_PROPERTIES,
		aliases: ["more info", "related", "attachments", "tool buttons"]
	},
	{
		anchor: "containerLayout",
		title: "Container Layout",
		groupId: "layout",
		scopes: ITEM_SCOPES,
		entityTypes: ["itemContainer", "itemcontainer"],
		properties: [
			"containerKind",
			"layout",
			"responsive",
			"printLayout",
			"showHeader",
			"showNestedBorder"
		],
		contentKeys: [
			"containerKind",
			"layout",
			"responsive",
			"printLayout",
			"showHeader",
			"showNestedBorder"
		],
		aliases: ["container", "nested border", "responsive"]
	},
	{
		anchor: "choiceLayout",
		title: "Choice Layout",
		groupId: "layout",
		scopes: ITEM_SCOPES,
		entityTypes: ["itemChoiceSingle", "itemChoiceMulti"],
		properties: [
			"layout",
			"size",
			"hideBorder",
			"choiceHideOptionBorder",
			"choiceGap",
			"optionPrefixMode",
			"choiceItems",
			"choiceItemsManualConfig",
			"choiceItemDataFields",
			"choiceItemDataFieldAutoValueFormat"
		],
		contentKeys: [
			"choiceItems",
			"choiceLayout",
			"optionPrefixMode"
		],
		aliases: ["choice items", "single choice", "multi choice"]
	},
	{
		anchor: "labels-overlay",
		title: "Labels Overlay",
		groupId: "layout",
		scopes: ITEM_SCOPES,
		properties: [
			"labelsMaxLines",
			"labelsOverlayPreset",
			"labelsSheetEnabled",
			"labelsCollapsedHeightMode",
			"labelsCollapsedHeightPercent",
			"labelsCollapsedHeightPx",
			"labelsOverflowMode",
			"labelsExpandBehavior",
			"labelsReserveCollapsedSpaceForMedia",
			"labelsHandlePosition",
			"labelsSheetBackgroundColor",
			"labelsSheetBackgroundOpacity",
			"labelsMaxExpandPercent",
			"labelsMinExpandPercent"
		],
		contentKeys: [
			"labelsOverlayPreset",
			"labelsSheetEnabled",
			"labelsOverflowMode"
		],
		aliases: ["label sheet", "overlay", "collapsed labels"]
	},
	{
		anchor: "keyboard-settings",
		title: "Keyboard Settings",
		groupId: "layout",
		scopes: ITEM_SCOPES,
		entityTypes: ["itemTextInput", "itemTextInputMultiline"],
		properties: [
			"textInputKeyboardType",
			"textInputKeyboardAutoCapitalize",
			"textInputKeyboardAutoCorrect",
			"textInputKeyboardReturnKeyType",
			"textInputKeyboardReturnKeySubmitsItem"
		],
		contentKeys: [
			"textInputKeyboardType",
			"textInputKeyboardAutoCapitalize",
			"textInputKeyboardAutoCorrect",
			"textInputKeyboardReturnKeyType",
			"textInputKeyboardReturnKeySubmitsItem"
		],
		aliases: ["keyboard", "input keyboard", "return key ok", "submit from keyboard"]
	},
	{
		anchor: "text-input-options",
		title: "Text Input Options",
		groupId: "layout",
		scopes: ITEM_SCOPES,
		entityTypes: ["itemTextInput", "itemTextInputMultiline"],
		properties: [
			"textInputPlaceholder",
			"textInputDefaultValue",
			"textInputMaxLength",
			"textInputMaskType",
			"textInputCustomMask",
			"textInputCustomMask2",
			"textInputCurrencySymbol",
			"textInputCurrencySeparator",
			"textInputNumberOfLines",
			"inputType",
			"inputMin",
			"inputMax",
			"inputStep",
			"inputPrecision"
		],
		contentKeys: [
			"textInputPlaceholder",
			"textInputDefaultValue",
			"textInputMaxLength",
			"inputType"
		],
		aliases: ["text input", "placeholder", "mask", "number input"]
	},
	{
		anchor: "yes-no-options",
		title: "Yes/No Options",
		groupId: "layout",
		scopes: ITEM_SCOPES,
		entityTypes: ["itemYesNo"],
		properties: [
			"yesNoShowNa",
			"yesNoAdvanceOnSelect",
			"yesNoLinkOnSelect",
			"yesNoLinkActionType",
			"yesLinkActionType",
			"noLinkActionType",
			"naLinkActionType",
			"yesNoYesLinkId",
			"yesNoNoLinkId",
			"yesNoNaLinkId"
		],
		contentKeys: [
			"yesNoShowNa",
			"yesNoAdvanceOnSelect"
		],
		aliases: ["yes no", "na option"]
	},
	{
		anchor: "picker-options",
		title: "Picker Options",
		groupId: "layout",
		scopes: ITEM_SCOPES,
		entityTypes: ["itemPicker"],
		properties: [
			"pickerItemViewType",
			"pickerVisualStyle",
			"pickerVisualColumns",
			"pickerVisualItemMaxWidth",
			"pickerVisualItemMaxWidthWeb",
			"pickerVisualItemMaxWidthMobile",
			"pickerVisualImageFit",
			"pickerVisualImageKey",
			"pickerVisualColorKey",
			"pickerItemsDatasource",
			"pickerItemsManualConfig",
			"pickerItemDataFields",
			"pickerItemDataFieldAutoValueFormat",
			"pickerItemPlaceholder",
			"pickerItemDefaultValue",
			"pickerLockWhenLaunchVarProvided",
			"pickerAutoSelectSingleOption",
			"pickerLockSingleOption",
			"optionPrefixMode",
			"pickerItems"
		],
		contentKeys: [
			"pickerItems",
			"pickerItemsDatasource",
			"pickerItemPlaceholder"
		],
		aliases: ["picker", "datasource picker", "visual picker"]
	},
	{
		anchor: "ranking-options",
		title: "Ranking Options",
		groupId: "layout",
		scopes: ITEM_SCOPES,
		entityTypes: ["itemRanking"],
		properties: [
			"config",
			"itemsDatasource",
			"associatedContentTemplate",
			"items"
		],
		contentKeys: [
			"config",
			"itemsDatasource",
			"associatedContentTemplate",
			"items"
		],
		aliases: ["ranking", "rank items"]
	},
	{
		anchor: "date-picker-options",
		title: "Date Picker Options",
		groupId: "layout",
		scopes: ITEM_SCOPES,
		entityTypes: ["itemDate", "itemTime", "itemDateTime"],
		properties: [
			"dateTimeType",
			"dateTimeInitialDate",
			"dateTimeMinuteInterval",
			"dateTimeAdvanceOnSelect",
			"dateTimePickerInline"
		],
		contentKeys: [
			"dateTimeType",
			"dateTimeInitialDate",
			"dateTimeMinuteInterval",
			"dateTimeAdvanceOnSelect",
			"dateTimePickerInline"
		],
		aliases: ["date", "time", "datetime"]
	},
	{
		anchor: "barcode-scanner-options",
		title: "Barcode Scanner Options",
		groupId: "layout",
		scopes: ITEM_SCOPES,
		entityTypes: ["itemBarcodeScanner"],
		properties: [
			"barcodeTypes",
			"barcodeManualEntryMultiline",
			"barcodeAllowEditScannedValue",
			"barcodeNormalizeTrim",
			"barcodeNormalizeStripLineBreaks",
			"barcodeNormalizeCase",
			"barcodeNormalizeUpcAFromEan13",
			"barcodeExpectedValue",
			"barcodeExpectedMatchMode",
			"barcodeValidationPattern",
			"barcodeValidationMessage",
			"textInputKeyboardType",
			"textInputKeyboardAutoCapitalize",
			"textInputKeyboardReturnKeyType",
			"textInputKeyboardReturnKeySubmitsItem"
		],
		contentKeys: [
			"barcodeTypes",
			"barcodeManualEntryMultiline",
			"barcodeAllowEditScannedValue",
			"barcodeNormalizeTrim",
			"barcodeNormalizeStripLineBreaks",
			"barcodeNormalizeCase",
			"barcodeNormalizeUpcAFromEan13",
			"barcodeExpectedValue",
			"barcodeExpectedMatchMode",
			"barcodeValidationPattern",
			"barcodeValidationMessage",
			"keyboardType",
			"keyboardAutoCapitalize",
			"keyboardReturnKeyType",
			"keyboardReturnKeySubmitsItem"
		],
		aliases: ["barcode", "qr code", "scanner", "manual entry", "return key", "keyboard", "normalize", "validation", "expected", "regex"]
	},
	{
		anchor: "sketchpad-options",
		title: "Sketchpad Options",
		groupId: "layout",
		scopes: ITEM_SCOPES,
		entityTypes: ["itemSketchPad"],
		properties: [
			"sketchPadBackgroundColor",
			"sketchPadPenColor",
			"sketchPadPenWidth",
			"sketchPadHeight"
		],
		contentKeys: [
			"sketchPadBackgroundColor",
			"sketchPadPenColor",
			"sketchPadPenWidth",
			"sketchPadHeight"
		],
		aliases: ["drawing", "signature", "sketch"]
	},
	{
		anchor: "styles",
		title: "Styling",
		groupId: "styling",
		scopes: ALL_SCOPES,
		properties: [
			"backgroundColor",
			"color",
			"label2Color",
			"styles",
			"classes",
			"theme",
			"themes",
			"stylesheet",
			"stylesheets",
			"themeColors",
			"fonts"
		],
		contentKeys: [
			"styles",
			"classes",
			"theme",
			"stylesheet",
			"themeColors",
			"fonts"
		],
		aliases: ["style", "theme", "css", "classes", "colors"]
	},
	{
		anchor: "link",
		title: "Link",
		groupId: "linking",
		scopes: ITEM_SCOPES,
		properties: [
			"linkOnCheck",
			"linkId",
			"linkActionType",
			"yesNoLinkOnSelect",
			"yesNoLinkActionType",
			"yesLinkActionType",
			"noLinkActionType",
			"naLinkActionType",
			"yesNoYesLinkId",
			"yesNoNoLinkId",
			"yesNoNaLinkId"
		],
		contentKeys: [
			"linkOnCheck",
			"linkId",
			"linkActionType"
		],
		aliases: ["goto", "jump", "link on check"]
	},
	{
		anchor: "linking-options",
		title: "Linking Options",
		groupId: "linking",
		scopes: ITEM_SCOPES,
		entityTypes: ["itemChoiceSingle", "itemPicker"],
		properties: [
			"choiceAdvanceOnSelect",
			"choiceLinkOnSelect",
			"choiceLinkActionType",
			"pickerAdvanceOnSelect",
			"pickerLinkOnSelect",
			"pickerLinkActionType"
		],
		contentKeys: [
			"choiceAdvanceOnSelect",
			"choiceLinkOnSelect",
			"pickerAdvanceOnSelect",
			"pickerLinkOnSelect"
		],
		aliases: ["advance on select", "link on select"]
	},
	{
		anchor: "valueTrigger",
		title: "Value Trigger",
		groupId: "logic",
		scopes: ITEM_SCOPES,
		properties: [
			"valueTrigger",
			"valueSticky",
			"calculatedDefaultValue"
		],
		contentKeys: [
			"valueTrigger",
			"valueSticky",
			"calculatedDefaultValue"
		],
		aliases: ["trigger", "calculated default"]
	},
	{
		anchor: "aiAction",
		title: "AI Action",
		groupId: "logic",
		scopes: ALL_SCOPES,
		properties: [
			"aiAction",
			"aiAssistant",
			"aiAssistantId",
			"aiAssistantFiles",
			"aiAssistantChecklistFiles"
		],
		contentKeys: [
			"aiAction",
			"aiAssistant"
		],
		aliases: ["ai", "assistant"]
	},
	{
		anchor: "functions",
		title: "Functions",
		groupId: "logic",
		scopes: ACTIVITY_SCOPES,
		properties: ["functions"],
		contentKeys: ["functions"],
		aliases: ["script", "javascript"]
	},
	{
		anchor: "filters",
		title: "Filters",
		groupId: "advanced",
		scopes: ALL_SCOPES,
		properties: FILTER_PROPERTIES,
		contentKeys: FILTER_PROPERTIES,
		aliases: ["show for", "filter tags", "groups"]
	},
	{
		anchor: "drivesFilters",
		title: "Filter Selector",
		groupId: "advanced",
		scopes: ITEM_SCOPES,
		properties: ["drivesFilters"],
		contentKeys: ["drivesFilters"],
		aliases: ["drive filters", "filter selector"]
	},
	{
		anchor: "id",
		title: "ID & Groups",
		groupId: "advanced",
		scopes: ALL_SCOPES,
		properties: [
			"id",
			"checklistId",
			"groupNames",
			"filterTags"
		],
		contentKeys: [
			"id",
			"groupNames",
			"filterTags"
		],
		aliases: ["identifier", "variable", "groups"]
	},
	{
		anchor: "print-options",
		title: "Print Options",
		groupId: "advanced",
		scopes: ALL_SCOPES,
		properties: PRINT_PROPERTIES,
		contentKeys: PRINT_PROPERTIES,
		aliases: ["print", "report", "pdf print"]
	},
	{
		anchor: "audio-options",
		title: "Audio Options",
		groupId: "advanced",
		scopes: ALL_SCOPES,
		properties: [
			"suppressAudio",
			"suppressAudioTitle",
			"suppressAudioEntityType",
			"suppressAudioCompletion",
			"suppressCompletionConfirmation",
			"suppressAudioValue",
			"backgroundAudioDuckingDuck",
			"backgroundAudioDuckingDuration",
			"backgroundAudioDuckingVolume"
		],
		contentKeys: [
			"suppressAudio",
			"suppressAudioTitle",
			"suppressAudioEntityType",
			"suppressAudioCompletion",
			"suppressCompletionConfirmation",
			"backgroundAudioDuckingDuck",
			"backgroundAudioDuckingDuration",
			"backgroundAudioDuckingVolume"
		],
		aliases: ["narration", "suppress audio", "ducking"]
	},
	{
		anchor: "authorProperties",
		title: "Author Properties",
		groupId: "advanced",
		scopes: ALL_SCOPES,
		properties: ["authorProperties"],
		contentKeys: ["authorProperties"],
		aliases: ["custom properties", "metadata"]
	},
	{
		anchor: "participant-completion",
		title: "Participant Completion",
		groupId: "advanced",
		scopes: ACTIVITY_SCOPES,
		properties: [
			"submitLabel",
			"lockOnSubmit",
			"submitLabelWhenComplete",
			"lockOnSubmitWhenComplete",
			"validationMode",
			"itemValueCommitMode",
			"autoScrollOnAdvance",
			"advanceOnAcknowledgeStrategy",
			"showRequiredAsterisk",
			"requiredIndicatorSymbol",
			"requiredIndicatorColor",
			"trackData",
			"trackLocation"
		],
		contentKeys: [
			"submitLabel",
			"lockOnSubmit",
			"validationMode",
			"itemValueCommitMode"
		],
		aliases: ["submit", "save and exit", "required indicator", "validation"]
	},
	{
		anchor: "timers",
		title: "Timers",
		groupId: "advanced",
		scopes: ITEM_SCOPES,
		properties: [
			"startTimer",
			"stopTimer",
			"startNamedTimers",
			"stopNamedTimers"
		],
		contentKeys: [
			"startTimer",
			"stopTimer",
			"startNamedTimers",
			"stopNamedTimers"
		],
		aliases: ["timer", "named timers"]
	},
	{
		anchor: "tracking",
		title: "Tracking",
		groupId: "advanced",
		scopes: ITEM_SCOPES,
		properties: [
			"startTracking",
			"stopTracking",
			"useAsSessionName"
		],
		contentKeys: [
			"startTracking",
			"stopTracking",
			"useAsSessionName"
		],
		aliases: ["location tracking", "session name"]
	},
	{
		anchor: "on-complete",
		title: "On Complete",
		groupId: "advanced",
		scopes: ITEM_SCOPES,
		properties: [
			"saveOnCheck",
			"saveAndExitOnCheck",
			"generateReportOnCheck",
			"generateReportOnCheckTemplate"
		],
		contentKeys: [
			"saveOnCheck",
			"saveAndExitOnCheck",
			"generateReportOnCheck",
			"generateReportOnCheckTemplate"
		],
		aliases: ["on check", "generate report", "save on check"]
	},
	{
		anchor: "relatedItems",
		title: "Related Items",
		groupId: "advanced",
		scopes: ACTIVITY_SCOPES,
		properties: ["relatedItems"],
		contentKeys: ["relatedItems"],
		aliases: ["related", "linked activity"]
	},
	{
		anchor: "attached-data-sources",
		title: "Attached Data Sources",
		groupId: "advanced",
		scopes: ACTIVITY_SCOPES,
		properties: [
			"dataSources",
			"externalResources"
		],
		contentKeys: [
			"dataSources",
			"externalResources"
		],
		aliases: ["data sources", "external resources"]
	},
	{
		anchor: "content-model-references",
		title: "Content Model References",
		groupId: "advanced",
		scopes: ACTIVITY_SCOPES,
		properties: ["contentModel"],
		contentKeys: ["contentModel"],
		aliases: ["content model"]
	},
	{
		anchor: "activity-behavior",
		title: "Activity Behavior",
		groupId: "advanced",
		scopes: ACTIVITY_SCOPES,
		properties: [
			"debugMode",
			"autosaveOnCheck",
			"pricingQtyDisplayMode",
			"pricingSelectionImageMode",
			"disableMediaOptimization",
			"fullscreenStartMode",
			"fullscreenSuppressHideLabelsToggle",
			"fullscreenTransition",
			"fullscreenTransitionIn",
			"fullscreenTransitionOut",
			"fullscreenTransitionDelay"
		],
		contentKeys: [
			"debugMode",
			"autosaveOnCheck",
			"pricingSelectionImageMode",
			"disableMediaOptimization",
			"fullscreenStartMode"
		],
		aliases: ["behavior", "fullscreen start", "transition", "pricing images", "selection image", "procedure card images"]
	}
];

export default PROPERTY_PANEL_REGISTRY;
